export const sq = (url, w = 1600) =>
  url && url.includes("images.squarespace-cdn.com") && !url.includes("?")
    ? `${url}?format=${w}w`
    : url;

// Site origin for absolute share URLs — inlined at build time so pre-rendered
// HTML carries the correct production URL (never localhost from the crawler).
const SITE = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");

export const useTitle = (title, description, image) => {
  if (typeof document === "undefined") return;
  document.title = title;
  const set = (sel, val) => {
    const el = document.querySelector(sel);
    if (el && val) el.setAttribute("content", val);
  };
  set('meta[property="og:title"]', title);
  set('meta[name="twitter:title"]', title);
  if (description) {
    set('meta[name="description"]', description);
    set('meta[property="og:description"]', description);
    set('meta[name="twitter:description"]', description);
  }
  const img = image || "/og-image.jpg";
  const absImg = img.startsWith("http") ? img : `${SITE}${img}`;
  set('meta[property="og:image"]', absImg);
  set('meta[name="twitter:image"]', absImg);
};
